import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomerHeader, { CustomerFooter } from "@/components/customer/CustomerHeader";
import SearchBar from "@/components/customer/SearchBar";
import HotelCard from "@/components/customer/HotelCard";
import BannerArt from "@/components/customer/BannerArt";
import { useShopper } from "@/components/customer/ShopperProvider";
import { Skeleton } from "@/components/ui/skeleton";
import { http, useStay, stayQuery, errMsg, ctxParams } from "@/lib/api";
import { useT } from "@/lib/i18n";

export default function PromoPage() {
  const { id } = useParams();
  const stay = useStay();
  const key = stayQuery(stay);
  const t = useT();
  const { member, country } = useShopper();
  const [c, setC] = useState(null);
  const [list, setList] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => { http.get(`/public/featured-promos/${id}`).then((r) => setC(r.data)).catch((e) => setError(errMsg(e))); }, [id]);
  useEffect(() => {
    setList(null);
    http.get(`/public/search?${key}`, { params: { ...ctxParams(country), campaign: id } }).then((r) => setList(r.data.results)).catch((e) => setError(errMsg(e)));
  }, [id, key, country, member?.id]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <CustomerHeader />
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        {error ? <p data-testid="promo-error" className="py-16 text-center text-red-600">{t(error)}</p> : <>
          <div className="aspect-[4/3] overflow-hidden rounded-2xl sm:aspect-[3.2/1]" data-testid="promo-banner">
            {!c ? <Skeleton className="h-full w-full" /> : <BannerArt c={c} hero />}
          </div>
          {c && <p data-testid="promo-title" className="mt-4 text-sm font-semibold text-[#2F7A54]"><span className="sr-only">{c.title} · </span>{t("Hemat hingga {n}% di {p} properti", { n: Math.round(c.max_discount), p: c.property_ids.length })}</p>}
          <div className="mt-8"><SearchBar initial={stay} compact target={`/promo/${id}`} /></div>
          <div className="mt-6 space-y-4" data-testid="promo-results">
            {!list ? [0, 1].map((i) => <Skeleton key={i} className="h-56 rounded-2xl" />)
              : list.length === 0 ? <p data-testid="promo-empty" className="py-12 text-center text-slate-500">{t("Belum ada properti yang tersedia untuk tanggal ini.")}</p>
              : list.map((r) => <HotelCard key={r.property.id} item={r} stay={stay} />)}
          </div>
        </>}
      </main>
      <CustomerFooter />
    </div>
  );
}
